module.exports = __webpack_public_path__ + "img/HeterakisGallinarum.dbaf8680.png";